import { render } from "./BlListPaginationSettings.vue?vue&type=template&id=d488384c&scoped=true"
import script from "./BlListPaginationSettings.vue?vue&type=script&lang=js"
export * from "./BlListPaginationSettings.vue?vue&type=script&lang=js"

import "./BlListPaginationSettings.vue?vue&type=style&index=0&id=d488384c&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d488384c"]])

export default __exports__